import { render, staticRenderFns } from "./CreatePool.vue?vue&type=template&id=53f38e60&"
import script from "./CreatePool.vue?vue&type=script&lang=js&"
export * from "./CreatePool.vue?vue&type=script&lang=js&"
import style0 from "./CreatePool.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports